/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/user_organization_roles-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/user_organization_roles-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/user_organization_roles-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-user_organization_roles-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/user_organization_roles.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-22T23:44:13.692Z
 * Source config: config/entities/user_organization_roles-entity-config.ts
 * Public fields: 11/11 total fields
 */

import { Type, Static } from "@sinclair/typebox";

// TypeBox schemas for runtime validation (public fields only)
export const UserOrganizationRolesSchema = Type.Object({
  user_id: Type.String({ format: "uuid" }), // user_id field
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  role_id: Type.String({ format: "uuid" }), // role_id field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  trig_user_email: Type.Union([Type.String(), Type.Null()]), // trig_user_email field
  trig_user_full_name: Type.Union([Type.String(), Type.Null()]), // trig_user_full_name field
  trig_organization_name: Type.Union([Type.String(), Type.Null()]), // trig_organization_name field
  trig_organization_slug: Type.Union([Type.String(), Type.Null()]), // trig_organization_slug field
  trig_role_name: Type.Union([Type.String(), Type.Null()]), // trig_role_name field
  trig_role_description: Type.Union([Type.String(), Type.Null()]), // trig_role_description field
});

export const CreateUserOrganizationRolesSchema = Type.Object({
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  trig_user_email: Type.Union([Type.String(), Type.Null()]), // trig_user_email field
  trig_user_full_name: Type.Union([Type.String(), Type.Null()]), // trig_user_full_name field
  trig_organization_name: Type.Union([Type.String(), Type.Null()]), // trig_organization_name field
  trig_organization_slug: Type.Union([Type.String(), Type.Null()]), // trig_organization_slug field
  trig_role_name: Type.Union([Type.String(), Type.Null()]), // trig_role_name field
  trig_role_description: Type.Union([Type.String(), Type.Null()]), // trig_role_description field
});

export const UpdateUserOrganizationRolesSchema = Type.Object({
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  trig_user_email: Type.Union([Type.String(), Type.Null()]), // trig_user_email field
  trig_user_full_name: Type.Union([Type.String(), Type.Null()]), // trig_user_full_name field
  trig_organization_name: Type.Union([Type.String(), Type.Null()]), // trig_organization_name field
  trig_organization_slug: Type.Union([Type.String(), Type.Null()]), // trig_organization_slug field
  trig_role_name: Type.Union([Type.String(), Type.Null()]), // trig_role_name field
  trig_role_description: Type.Union([Type.String(), Type.Null()]), // trig_role_description field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type UserOrganizationRolesRow = Static<
  typeof UserOrganizationRolesSchema
>;
export type UserOrganizationRolesInsert = Static<
  typeof CreateUserOrganizationRolesSchema
>;
export type UserOrganizationRolesUpdate = Static<
  typeof UpdateUserOrganizationRolesSchema
>;

// Legacy type aliases for backward compatibility
export type UserOrganizationRoles = UserOrganizationRolesRow;
export type CreateUserOrganizationRoles = UserOrganizationRolesInsert;
export type UpdateUserOrganizationRoles = Static<
  typeof UpdateUserOrganizationRolesSchema
>;

// Field configuration metadata
export const UserOrganizationRolesFieldConfig = {
  filterable: ["user_id", "organization_id", "role_id"] as const,
  sortable: ["created_at"] as const,
  searchable: [] as const,
  required: ["user_id", "organization_id", "role_id"] as const,
  readonly: ["user_id", "organization_id", "role_id", "created_at"] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from "../../../../../config/search/global-search-config.js";

export interface UserOrganizationRolesQueryOptions
  extends UnifiedQueryOptions {}

// Response types for API operations
export interface UserOrganizationRolesResponse {
  data: UserOrganizationRoles[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleUserOrganizationRolesResponse {
  data: UserOrganizationRoles | null;
  error: Error | null;
}
